const Body = ({ handleHubChange }) => {
  return (
    <button
      className='bg-secondary rounded-xl p-4'
      onClick={() => handleHubChange('BODY_PROGRESS')}
    >
      <div className='flex items-center gap-4 mb-4'>
        <h2 className='text-lg font-semibold'>Body Log</h2>
      </div>
      <p className='text-sm text-gray-400 mb-4 text-left'>
        Record body progress
      </p>
    </button>
  );
};

export default Body;
